import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-shared-regulatory-document-viewer',
  templateUrl: './regulatory-document-viewer.component.html',
  styleUrls: ['./regulatory-document-viewer.component.scss']
})
export class RegulatoryDocumentViewerComponentShared implements OnInit {

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data
  ) { }

  ngOnInit() {

  }

}
